import {Action, InitialState} from './type';
import {
    STATISTIC_FETCH_SUCCESS,
    STATISTIC_FETCH_ERROR,
    STATISTIC_FILTER_AUTHOR,
    STATISTIC_FILTER_RECIPIENT,
    STATISTIC_FILTER_RECIPIENT_TEAM,
    STATISTIC_SORTING_DERECTION,
    STATISTIC_FETCH_REQUEST
} from './constans';

const initialState: InitialState = {
    feedbacks: [],
    stateSuccess: false,
    stateError: false,
    loading: false,
    authorFilter: '',
    recipientFilter: '',
    recipientTeamFilter: '',
    derection: ''
};

export default (state = initialState, action: Action) => {
    switch (action.type) {
        case STATISTIC_FETCH_REQUEST:
            return {
                ...state,
                loading: true
            };
        case STATISTIC_FETCH_SUCCESS:
            return {
                ...state,
                feedbacks: action.data,
                loading: false
            };
        case STATISTIC_FETCH_ERROR:
            return {
                ...state,
                loading: false
            };
        case STATISTIC_FILTER_AUTHOR:
            return {
                ...state,
                authorFilter: action.payload.value
            };
        case STATISTIC_FILTER_RECIPIENT:
            return {
                ...state,
                recipientFilter: action.payload.value
            };
        case STATISTIC_FILTER_RECIPIENT_TEAM:
            return {
                ...state,
                recipientTeamFilter: action.payload.value
            };
        case STATISTIC_SORTING_DERECTION:
            return {
                ...state,
                derection: action.payload.derection
            };
        default: return state;
    }
};
